const ERROR = "ERROR"
const CHOICE = "CHOICE"
const DEALING = "DEALING"
const WAITING = "WAITING"
const GAME = "GAME"
const INSURANCE = "INSURANCE"
const LOADING = "LOADING"

export { ERROR, CHOICE, DEALING, GAME, INSURANCE, LOADING, WAITING }